import React from "react";
import {INormalizedProduct} from "../../models/NormalizedProduct";
import BestPriceDisplay from "../Products/BestPriceDisplay";
import {Checkbox, IColumn, IconButton, SelectionMode, Separator, ShimmeredDetailsList, Text, useTheme} from "@fluentui/react";
import {ColumnGenerator} from "../../logic/Columns/ColumnGenerator";
import {titleCaseType} from "./linkedItemHelpers";

interface ISuggestedLinksTableProps {
    type: string;
    products: INormalizedProduct[];
    loading: boolean;
    canEdit: boolean;
    curatedIds: Set<string>;
    selectedIds: Set<string>;
    onToggleSelect: (productId: string, checked: boolean) => void;
    onViewDetails: (product: INormalizedProduct) => void;
}

export const SuggestedLinksTable: React.FC<ISuggestedLinksTableProps> = (props) => {
    const theme = useTheme();

    const columns: IColumn[] = [];

    if (props.canEdit) {
        columns.push({
            key: 'suggestedSelect',
            name: '',
            minWidth: 70,
            maxWidth: 70,
            onRender: (item: INormalizedProduct) => {
                if (props.curatedIds.has(item.id)) {
                    return <Text variant="small" styles={{root: {color: theme.palette.neutralSecondary}}}>Added</Text>;
                }
                return (
                    <Checkbox
                        checked={props.selectedIds.has(item.id)}
                        ariaLabel="Select suggested link"
                        onChange={(_e, checked) => props.onToggleSelect(item.id, checked ?? false)}
                    />
                );
            }
        });
    }

    columns.push(
        ColumnGenerator('Name', 'name'),
        ColumnGenerator('Best Price', 'bestPrice', 150, 200, (item: INormalizedProduct) => <BestPriceDisplay product={item} />),
        ColumnGenerator('', 'viewDetails', 60, 60, (item: INormalizedProduct) => (
            <IconButton
                iconProps={{iconName: 'View'}}
                title="View Details"
                ariaLabel="View Details"
                onClick={() => props.onViewDetails(item)}
            />
        ))
    );

    return (
        <div>
            <Separator>{titleCaseType(props.type)}</Separator>
            <ShimmeredDetailsList
                enableShimmer={props.loading}
                items={props.products ?? []}
                selectionMode={SelectionMode.none}
                columns={columns}
            />
        </div>
    );
};
